module.exports = __webpack_public_path__ + "img/t6-blue.5c3a09b1.png";